var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 140,
    viewBox: "0 0 173 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7002 42.4273C45.1745 41.7431 44.9578 40.9203 45.026 40.1257C45.1023 39.2268 45.5417 38.3639 46.3142 37.772C47.769 36.6563 49.8519 36.9312 50.9675 38.386C51.4933 39.0683 51.71 39.893 51.6418 40.6876C51.5655 41.5865 51.1261 42.4494 50.3535 43.0413C48.8987 44.157 46.8159 43.8821 45.7002 42.4273Z",
    fill: "url(#paint0_linear_1965_74586)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.952 3.58215V4.67976C108.906 4.40285 108.894 4.12192 108.918 3.84501C108.926 3.75672 108.936 3.66843 108.952 3.58215Z",
    fill: "url(#paint1_linear_1965_74586)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.548 21.2826H145.42C145.795 21.2184 146.177 21.2204 146.548 21.2826Z",
    fill: "url(#paint2_linear_1965_74586)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3591 45.0502C76.3591 54.8464 73.1766 63.8982 67.7869 71.2283C66.4646 73.0302 65.0078 74.7258 63.4326 76.305C55.4463 84.3073 44.41 89.2676 32.2139 89.2957H11.2269C11.1326 89.2977 11.0383 89.2997 10.944 89.2997C4.90011 89.2997 0 84.3996 0 78.3557C0 76.614 0.40734 74.9666 1.13373 73.5037C1.35245 73.1044 1.5812 72.7091 1.81597 72.3178C4.21386 68.3147 7.31204 64.7811 10.944 61.8855C16.9176 57.1159 24.33 54.0739 32.4246 53.516C32.7116 56.2932 32.1517 59.1164 30.7993 61.5846C29.9184 63.1878 28.7064 64.6406 27.1714 65.8325C29.0736 65.8646 30.9859 65.5436 32.8079 64.8493C34.1583 64.3376 35.4546 63.6233 36.6585 62.7002C39.5701 60.4669 41.4483 57.3847 42.2088 54.0638C42.2469 53.9033 42.281 53.7408 42.3131 53.5782C44.9277 53.3575 47.5463 52.6532 50.0426 51.4292C57.186 47.9236 61.5504 41.0229 62.1464 33.6286C59.0622 31.618 55.5065 30.4141 51.8344 30.1412C48.1082 29.8642 44.2595 30.5465 40.6637 32.3103C39.3675 32.9464 38.1615 33.6948 37.0559 34.5376C36.0285 35.3182 35.0854 36.177 34.2326 37.1081C33.7229 36.8532 33.2012 36.6265 32.6694 36.4338C28.4195 34.8707 23.5555 35.2419 19.5021 37.7321C19.0547 38.005 18.6192 38.306 18.1938 38.6311C17.0641 39.4979 16.0889 40.4952 15.2742 41.5828C17.1103 41.1132 19.0105 41.031 20.8566 41.3219C21.5469 41.4303 22.2291 41.5908 22.8953 41.8035C18.6393 44.5144 14.6421 47.5966 10.944 50.9997V0.804688H32.2139C46.9684 0.8388 60.0274 8.09466 68.0438 19.2253C68.5273 19.8955 68.9929 20.5817 69.4383 21.282C70.9072 23.5796 72.1673 26.0236 73.1947 28.584C75.2354 33.6748 76.3591 39.231 76.3591 45.0502Z",
    fill: "url(#paint3_linear_1965_74586)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.952 3.58215V4.67976C108.906 4.40285 108.894 4.12192 108.918 3.84501C108.926 3.75672 108.936 3.66843 108.952 3.58215Z",
    fill: "url(#paint4_linear_1965_74586)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.918 3.84501C108.894 4.12192 108.906 4.40285 108.952 4.67976L108.952 79.0621C108.952 84.7147 104.367 89.2998 98.7126 89.2998C93.058 89.2998 88.4749 84.7147 88.4749 79.0621V21.236C77.1918 21.236 68.0437 12.0879 68.0437 0.804803H108.952L108.952 3.58215C108.936 3.66843 108.926 3.75672 108.918 3.84501Z",
    fill: "url(#paint5_linear_1965_74586)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.023 0.804803V79.0621C136.023 84.7147 131.438 89.2998 125.784 89.2998C120.129 89.2998 115.546 84.7147 115.546 79.0621V0.804803H136.023Z",
    fill: "url(#paint6_linear_1965_74586)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.856 0.804803V0.850955C172.856 12.1341 163.71 21.2821 152.425 21.2821L146.548 21.2826C146.177 21.2204 145.795 21.2184 145.42 21.2826L142.663 21.2821V0.804803H172.856Z",
    fill: "url(#paint7_linear_1965_74586)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.81 38.0698C172.81 43.7244 168.227 48.3074 162.573 48.3074H142.617V27.8301H145.428C145.793 27.8903 146.167 27.8923 146.536 27.8301H162.573C168.227 27.8301 172.81 32.4152 172.81 38.0698Z",
    fill: "url(#paint8_linear_1965_74586)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.428 27.8301H146.536C146.167 27.8923 145.793 27.8903 145.428 27.8301Z",
    fill: "url(#paint9_linear_1965_74586)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.952 3.58215V4.67976C108.906 4.40285 108.894 4.12192 108.918 3.84501C108.926 3.75672 108.936 3.66843 108.952 3.58215Z",
    fill: "url(#paint10_linear_1965_74586)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.428 27.8301C145.793 27.8903 146.167 27.8923 146.536 27.8301H145.428Z",
    fill: "url(#paint11_linear_1965_74586)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.548 21.2826H145.42C145.795 21.2184 146.177 21.2204 146.548 21.2826Z",
    fill: "url(#paint12_linear_1965_74586)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7741 99.9453H74.9211V119.565C75.9951 118.688 76.95 117.915 77.9004 117.136C79.417 115.895 80.9268 114.646 82.4524 113.417C82.6344 113.271 82.9018 113.159 83.131 113.159C86.4293 113.143 89.7276 113.148 93.026 113.15C93.1024 113.15 93.1765 113.163 93.4259 113.188C88.029 117.605 82.7557 121.921 77.4555 126.26C82.758 130.601 88.0425 134.926 93.4259 139.33C93.1563 139.35 93.0012 139.373 92.8485 139.373C89.6557 139.373 86.463 139.384 83.2703 139.359C82.9692 139.359 82.6164 139.218 82.3783 139.027C79.9315 137.054 77.5049 135.059 74.9705 132.987V139.33H66.7719V99.9453H66.7741Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3616 139.319H52.2641C52.2349 139.173 52.2034 139.014 52.1697 138.841C52.1158 138.845 52.0529 138.836 52.0035 138.856C48.1277 140.387 44.2789 140.308 40.5604 138.441C37.0419 136.677 34.685 133.833 33.5795 130.051C32.5595 126.569 32.865 123.144 34.5839 119.938C36.7318 115.93 40.0728 113.438 44.6047 112.757C50.8104 111.827 56.5196 114.921 59.1708 120.572C59.9168 122.163 60.3437 123.854 60.3527 125.627C60.3729 130.058 60.3908 134.489 60.4066 138.919C60.4066 139.041 60.3819 139.164 60.3639 139.315L60.3616 139.319ZM46.6403 131.703C49.7746 131.698 52.2686 129.256 52.1832 126.135C52.1023 123.189 49.8892 120.761 46.6897 120.774C43.4925 120.787 41.2187 123.239 41.2367 126.245C41.2547 129.379 43.6475 131.64 46.6403 131.703Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.118 130.359C119.738 134.327 117.258 137.218 113.396 138.782C107.875 141.018 102.867 139.993 98.5262 136.027C96.0884 133.801 94.7516 130.927 94.4437 127.588C94.1382 124.256 94.9111 121.201 96.7962 118.482C99.0362 115.251 102.155 113.31 106.078 112.737C109.569 112.227 112.809 112.944 115.714 114.923C118.743 116.986 120.682 119.837 121.482 123.434C121.599 123.957 121.428 124.198 120.907 124.384C115.539 126.29 110.18 128.224 104.82 130.152C104.721 130.188 104.633 130.251 104.476 130.336C105.379 131.219 106.462 131.619 107.657 131.698C110.093 131.86 112.176 130.556 113.124 128.31C113.243 128.029 113.357 127.903 113.683 128.006C116.132 128.79 118.588 129.561 121.114 130.359H121.118ZM102.636 125.413C105.734 124.288 108.662 123.223 111.693 122.122C109.812 120.682 107.88 120.336 105.808 121.257C104.085 122.023 103.067 123.394 102.636 125.413Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.742 130.309C158.083 132.553 162.963 132.274 164.617 127.904C167.194 128.716 169.777 129.527 172.357 130.338C170.775 135.948 164.967 140.541 158.051 139.844C150.79 139.114 145.532 133.151 145.68 125.979C145.826 118.928 151.23 113.246 158.101 112.631C165.688 111.952 171.928 117.502 172.858 124.13C170.025 125.145 167.169 126.163 164.318 127.192C161.478 128.217 158.64 129.253 155.742 130.306V130.309ZM153.94 125.415C156.984 124.307 159.934 123.233 162.981 122.123C161.004 120.625 159.004 120.319 156.896 121.362C155.256 122.173 154.281 123.523 153.94 125.415Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.719 104.008H134.92V113.323H140.993V120.005H134.952C134.952 120.875 134.952 121.652 134.952 122.43C134.952 124.838 134.949 127.244 134.952 129.653C134.954 131.212 136.131 132.057 137.641 131.612C137.803 131.565 138.108 131.632 138.198 131.756C139.652 133.765 141.081 135.789 142.512 137.813C142.571 137.894 142.593 138.002 142.627 138.09C138.542 141.011 132.772 140.357 129.442 136.681C127.623 134.672 126.74 132.329 126.731 129.667C126.704 121.302 126.722 112.939 126.722 104.574V104.008H126.719Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6231 112.574V121.743H24.9945C23.1049 121.743 21.5299 123.193 21.3748 125.076C21.3681 125.174 21.3614 125.273 21.3614 125.374C21.3614 125.475 21.3659 125.572 21.3748 125.673V139.947H12.2056V121.746C12.2258 116.702 16.3195 112.624 21.3614 112.621H21.3748V112.576H28.6231V112.574Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1965_74586",
    x1: 0,
    y1: 89.2998,
    x2: 172.856,
    y2: 0.804686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRectangle);
export default __webpack_public_path__ + "static/media/light-rectangle.43605a218f1b21b6209636d4f4593412.svg";
export { ForwardRef as ReactComponent };